import { SalesOrderStatus } from '../constants/sales-order-status.js';
// RMAs are for returns after delivery (DLV-D6), so a Shipped order still on its way is refused.
const RETURNABLE_SALES_ORDER_STATUS_IDS = new Set([
    SalesOrderStatus.DELIVERED,
    SalesOrderStatus.COMPLETE,
]);
/** Why an order can't take a Create RMA, or null when it can; the API refuses with it and the web hides the action. */
export function salesOrderRmaRefusal({ statusId, path, }) {
    if (path === 'CreditReturn')
        return "A Credit Return can't be returned.";
    if (!RETURNABLE_SALES_ORDER_STATUS_IDS.has(statusId)) {
        return 'Only a Delivered or Complete order can be returned.';
    }
    return null;
}
//# sourceMappingURL=sales-order-rma-refusal.js.map